import { createSelector } from '@ngrx/store';
import * as fromFreezeBlock from './freeze-block.reducer';
import * as fromUi from '@app/root-store/ui/ui.reducer';

export const selectState = createSelector(
  fromUi.selectState,
  fromUi.getFreezeBlock
);



export const selectUserHasWriteAccessPermission = createSelector(
  selectState,
  fromFreezeBlock.getUserHasWriteAccessPermission
);
export const selectBlockedEdition = createSelector(
  selectState,
  fromFreezeBlock.getBlockedEdition
);

export const selectBlocked = createSelector(
  selectState,
  selectBlockedEdition,
  selectUserHasWriteAccessPermission,
  (state, blockedEdition, hasWriteAccessPermission) => {
    console.log('selectBlocked', {
      blockedEdition,
      hasWriteAccessPermission,
    },  ((blockedEdition || blockedEdition === null) && hasWriteAccessPermission === false))
    return ((blockedEdition || blockedEdition === null) && hasWriteAccessPermission === false);
  });

export const selectHiddenBlocks = createSelector(
  selectState,
  fromFreezeBlock.getNewsletterContentBlocksHidden
);
